<!-- @format -->

<template>
  <a-tooltip :trigger="['focus']" placement="topLeft" overlayClassName="numeric-input">
    <span slot="title" v-if="value" class="numeric-input-title">
      {{ value !== '-' ? formatNumber(value) : '-' }}
    </span>
    <template slot="title" v-else>
      <!--            Input a number-->
    </template>
    <a-input-number
      :value="value"
      :addonBefore="addonBefore"
      @change="onChange"
      @blur="onBlur"
      :formatter="value => value.replace(/\D/g, '')"
      placeholder=""
      :min="0"
      style="width: 120px"
    />
    <span style="margin-left:15px ;font-size:12px;display:inline-block">{{ addonAfter }}</span>
  </a-tooltip>
</template>
<script>
function formatNumber(value) {
  value += '';
  const list = value.split('.');
  const prefix = list[0].charAt(0) === '-' ? '-' : '';
  let num = prefix ? list[0].slice(1) : list[0];
  let result = '';
  while (num.length > 3) {
    result = `,${num.slice(-3)}${result}`;
    num = num.slice(0, num.length - 3);
  }
  if (num) {
    result = num + result;
  }
  return `${prefix}${result}${list[1] ? `.${list[1]}` : ''}`;
}

export default {
  props: {
    addonAfter: {
      type: [Number, String],
      default: ''
    },
    addonBefore: {
      type: [Number, String],
      default: ''
    },
    value: {
      type: [Number, String],
      default: ''
    },
    min: {
      type: [Number, String],
      default: '1'
    }
  },
  methods: {
    formatNumber,
    onChange(value) {
      const reg = /^-?[0-9]*(\.[0-9]*)?$/;
      if ((!isNaN(value) && reg.test(value)) || value === '' || value === '-') {
        let targetValue = value - 0;
        if (!isNaN(value - 0)) {
          if (targetValue !== 1) {
            if (value) {
              this.$emit('input', Number(value));
            } else {
              this.$emit('input', '');
            }
          } else {
            this.$emit('input', Number(1));
          }
        }
      }
    },
    onBlur() {
      let { value, onChange } = this;
      // if (value === 0) {
      //   value = 1
      // }
      let valueTemp = '' + value;
      if (valueTemp.charAt(valueTemp.length - 1) === '.' || valueTemp === '-') {
        onChange({ value: valueTemp.slice(0, -1) });
      }
    }
  }
};
</script>
<style>
/**
 * /* to prevent the arrow overflow the popup container,
 *     or the height is not enough when content is empty
 *
 * @format
 */

.numeric-input .ant-tooltip-inner {
  min-width: 32px;
  min-height: 37px;
}

.numeric-input .numeric-input-title {
  font-size: 14px;
}
</style>
